/** Eager login/layout chrome; feature pages lazy-load on first route visit. */
import '@core/bootstrap/shell/pages/shared/LoginComponent.ts';
import '@core/bootstrap/shell/pages/shared/LayoutComponent.ts';
import { registerShellMainWebContent } from '@src/modules/shell-routing/infrastructure/shellMainPageRegistry.ts';
import { SHELL_MAIN_PAGE_MANIFEST } from '@src/modules/shell-routing/domain/shellFeatureManifest.ts';

for (const { pageId, customElementTag } of SHELL_MAIN_PAGE_MANIFEST) {
  registerShellMainWebContent(pageId, customElementTag);
}
